"use client";

import { useState } from "react";

type EmailProps = {
  itinerary: string;
  city: string;
  itinid: string;
};

export default function Email({ itinerary, city, itinid }: EmailProps) {
  const initialState = "Email Itinerary";
  const [buttonText, setButtonText] = useState(initialState);

  const changeText = (text: string) => {
    setButtonText(text);
    setTimeout(() => setButtonText(initialState), 2000);
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const form = event.target as HTMLFormElement;
    const emailElement = form.elements.namedItem(
      "emailaddress"
    ) as HTMLInputElement;
    const emailValue = emailElement.value;

    // Track the event
    try {
      // @ts-expect-error - gtag might not be defined in TypeScript
      window.gtag?.("event", "btn_click_email", {
        event_category: "button_click",
        event_label: emailValue,
        value: 1,
      });
    } catch (error) {
      console.error("Error tracking event:", error);
    }

    const ITINERARY_URL = `https://www.aitripmaker.com/show/${city}/${
      itinid !== "DEFAULT" ? `/${itinid}` : ""
    }`;
    const TEXT_TO_APPEND = `\n\nAccess Itinerary Here: ${ITINERARY_URL}\n\nGenerated By: aitripmaker.com \n`;

    try {
      fetch(
        "https://planvacation.azure-api.net/PlanVacationFunction/SendEmail",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Ocp-Apim-Subscription-Key": "67d5dc5cd0af45e785d1c91a074be19f",
          },
          body: JSON.stringify({
            itinerary:
              itinerary.replace("display:flex", "display:block") +
              TEXT_TO_APPEND,
            emailaddress: emailValue,
            htmlitinerary: `
            <div>
              ${itinerary.replace("display:flex", "display:block")}
              <br>
              Access Itinerary Here: <a href="${ITINERARY_URL}" target="_blank" rel="noopener noreferrer">${ITINERARY_URL}</a>
              <br>
              Generated By: <a href="https://www.aitripmaker.com" target="_blank" rel="noopener noreferrer">aitripmaker.com</a>
              <br>
            </div>
          `,
          }),
        }
      );
      changeText("Email Sent ✓");
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <form
      name="emailForm"
      id="emailFormID"
      className="flex flex-col gap-4 sm:flex-row w-full"
      onSubmit={handleSubmit}
    >
      <input
        type="email"
        required
        name="emailaddress"
        id="emailaddress"
        placeholder="Email Address"
        className="flex-grow px-4 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent "
      />
      <button
        id="emailSubmitButton"
        type="submit"
        className={`px-4 py-2 rounded-md font-medium transition-colors hover:cursor-pointer bg-blue-600 hover:bg-blue-700 text-white sm:mt-0 mt-2 disabled:opacity-70`}
      >
        {buttonText}
      </button>
    </form>
  );
}
